import { combineReducers } from "redux";

import country_list from "./_countries";
import country from "./_country";
import fetching from "./_fetching";

export default combineReducers({ country, country_list, fetching });
